import React from "react";
import { Link } from "react-router-dom";
import { getSolutionsByCategory } from "../pages/Solutions/solutions.config";

const CATEGORY_COLUMN = {
  "Technology & Digital Platforms": 1,
  "Media & Sports": 2,
  "Risk & Identity Management": 2,
  "Use Cases": 3,
  API: 3,
};

function columnGroups(grouped) {
  const cols = { 1: [], 2: [], 3: [] };
  grouped.forEach((g) => {
    const col = CATEGORY_COLUMN[g.category] || 3;
    cols[col].push(g);
  });
  return cols;
}

export default function SolutionsMegaMenu() {
  const grouped = getSolutionsByCategory();
  const cols = columnGroups(grouped);

  return (
    <div className="bg-white rounded-2xl shadow-2xl border border-zinc-200/70 p-8 w-[min(1100px,calc(100vw-32px))] grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-6">
      {[1, 2, 3].map((c) => (
        <div key={c}>
          {cols[c].map((g) => (
            <div key={g.category} className="mb-6 last:mb-0">
              <div className="text-base font-semibold text-zinc-900 mb-3">
                {g.category}
              </div>
              <ul className="space-y-3">
                {g.items.map((s) => (
                  <li key={s.slug}>
                    <Link
                      to={`/solutions/${s.slug}`}
                      className="block group"
                    >
                      <div className="font-medium text-zinc-900 group-hover:text-fuchsia-700 transition text-[15px]">
                        {s.title}
                      </div>
                      <div className="text-xs text-zinc-500 leading-snug mt-0.5 max-w-xs">
                        {s.short}
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ))}
      <div className="md:col-span-3 mt-2 pt-4 border-t border-zinc-200 flex items-center justify-between">
        <Link
          to="/solutions"
          className="text-sm font-semibold text-fuchsia-700 hover:text-fuchsia-800"
        >
          See every solution →
        </Link>
        <Link
          to="/contact?topic=sales"
          className="inline-flex items-center justify-center bg-fuchsia-700 text-white text-sm font-semibold px-4 py-2 rounded-full hover:bg-fuchsia-800 transition"
        >
          Contact Sales
        </Link>
      </div>
    </div>
  );
}
